import isEmpty from "lodash-es/isEmpty"

import type { TranslationObj } from "$/utils/lang"

import type { ICoachingChatDisclaimerQueryDto as IDisclaimerQueryDto } from "../../types"
import { coachingChatApiUtils as utils } from "../../utils"

const { getChatConversationModelFromDto, getChatNewMessageModelFromDto } = utils

const conversationAdapter: ReturnType<() => typeof getChatConversationModelFromDto> = getChatConversationModelFromDto

const newMessagesAdapter: ReturnType<() => typeof getChatNewMessageModelFromDto> = getChatNewMessageModelFromDto

function disclaimerAdapter(dto: IDisclaimerQueryDto): TranslationObj {
    return isEmpty(dto) ? null : dto.text
}

const adapters = { conversationAdapter, newMessagesAdapter, disclaimerAdapter }

export { adapters as coachingChatQueriesAdapters }
